import {SxType} from "@baseTypes/sx/sxTypes";

export const sx:SxType = {
    root:{
        position: 'absolute',
        left:'15px',
        top:'0',

        height: '100%',
        width: '1px',
        zIndex:1
    }
}